<template>
  <lazy-component>
    <div class="companies" :style="largeScreenContainer">
      <v-container>
        <p class="companies-desc">
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et
        </p>
        <IconBrands v-if="$vuetify.breakpoint.smAndDown" />

        <div v-else class="companies-brands">
          <IconGoogle />
          <IconDropbox />
          <IconUber />
          <IconMicrosoft />
          <IconFacebook />
        </div>
        <v-row>
          <v-col cols="12" md="4">
            <div class="companies-left">
              <div class="companies-title">
                Lorem ipsum dolor <br />
                sit amet, consetetur
              </div>
              <div class="companies-mini-desc">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut <br />
                labore et
              </div>
              <div class="companies-btn">
                <v-btn
                  color="#600DFF"
                  class="hero-cta white--text"
                  elevation="0"
                >
                  Get started
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="8">
            <div class="companies-grid">
              <div class="companies-grid-item" v-for="(n, idx) in 4" :key="idx">
                <div class="companies-grid-tag">
                  Guide
                </div>
                <div class="companies-grid-desc">
                  Lorem ipsum dolor sit amet, consetetur
                </div>
                <router-link class="companies-grid-url" to="/"
                  >Find out how</router-link
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </lazy-component>
</template>

<script>
import IconGoogle from "@/components/icons/IconGoogle";
import IconFacebook from "@/components/icons/IconFacebook";
import IconDropbox from "@/components/icons/IconDropbox";
import IconMicrosoft from "@/components/icons/IconMicrosoft";
import IconUber from "@/components/icons/IconUber";
import IconBrands from "@/components/icons/IconBrands";
export default {
  components: {
    IconGoogle,
    IconFacebook,
    IconDropbox,
    IconMicrosoft,
    IconUber,
    IconBrands,
  },
};
</script>

<style lang="scss">
.companies {
  text-align: center;
  padding: 40px 0;

  &-left {
    text-align: left;
  }

  &-title {
    font-size: 40px;
    font-weight: bold;
    color: #000;
    margin-bottom: 16px;
    text-align: left;
    position: relative;
    display: inline-block;
    z-index: 1;

    &::after {
      content: "";
      height: 47px;
      position: absolute;
      transform: translateY(-50%);
      background-color: #f2eee8;
      z-index: -1;
      width: 168px;
      right: 0;
      top: 30px;
    }
    &::before {
      content: "";
      background-color: #f2eee8;
      z-index: -1;
      height: 47px;
      width: 193px;
      position: absolute;
      left: -4px;
      bottom: 5px;
    }
  }
  &-mini-desc {
    font-size: 16px;
    text-align: left;
    line-height: 1.75;
    color: #575452;
  }
  &-desc {
    font-size: 20px;
    font-weight: bold;
  }
  &-brands {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 180px;

    .icon {
      margin-right: 27px;
      height: 43px;
    }
  }
  &-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 11px;
    padding-left: 20px;

    &-item {
      border: 2px solid #e4e6ea;
      display: flex;
      padding: 16px 24px;
      min-height: 235px;
      align-items: flex-start;
      flex-direction: column;
      justify-content: space-between;
      transition: all 0.2s;

      &:hover {
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
        transform: translateY(-4px);
      }
    }
    &-tag {
      font-weight: bold;
    }
    &-desc {
      font-size: 30px;
      text-align: left;
      line-height: 1.167;
    }
    &-url {
      color: #6021ff !important;
      text-decoration: none;
    }
  }
  &-btn {
    text-align: left;
    margin-top: 16px;
  }
}

@include smMax {
  .companies {
    padding: 1px;
    &-left {
      text-align: center;
    }
    &-title {
      font-size: 30px;
      text-align: center;
      margin-top: 47px;
      margin-bottom: 22px;

      &:after {
        width: 120px;
        height: 40px;
        right: 0;
        top: 25%;
      }
      &:before {
        width: 123px;
        height: 39px;
        left: -15px;
        bottom: 0;
        top: auto;
      }
    }
    &-desc {
      font-size: 16px;
      margin-bottom: 30px !important;
      line-height: 24px;
    }
    &-grid {
      grid-template-columns: 1fr;
      grid-gap: 0;
      padding-left: 0;
      &-item {
        margin-bottom: 13px;
        text-align: center;
      }
    }
    &-mini-desc {
      text-align: center;
      font-size: 18px;
      line-height: 34px;
      color: #575452;
    }
    &-btn {
      margin-top: 10px;
    }
  }
}
</style>
